export class Navigation {
	constructor() {
		this.open = false
		this.toggle = document.querySelectorAll('[data-toggle-nav]')

		this.checkSubmenuState()

		this.toggle.forEach((button) => {
			button.addEventListener('click', () => {
				this.open ? this.closeNavigation() : this.openNavigation()
			})
		})
	}
	openNavigation() {
		this.open = true
		document.documentElement.classList.add('nav-open')
	}
	closeNavigation() {
		this.open = false
		document.documentElement.classList.remove('nav-open')
	}
	checkSubmenuState() {
		const header = document.querySelector('.header')
		const menuLinks = document.querySelectorAll('.header__nav .menu-item')
		const submenu = document.querySelectorAll('.header__nav .submenu')

		menuLinks.forEach(menuLink => {
			menuLink.addEventListener('mouseenter', () => {
				if (menuLink.classList.contains('has-sub-menu')) {
					header.classList.add('submenu-open')
				}
			})
			menuLink.addEventListener('mouseleave', () => {
				if (menuLink.classList.contains('has-sub-menu')) {
					header.classList.remove('submenu-open')
				}
			})
		})
	}
	snapCloseNavigation() {}
}

export default () => {}